import { render, staticRenderFns } from "./ImpressaoFormularioNascimento.vue?vue&type=template&id=81d6b4f0&scoped=true&"
import script from "./ImpressaoFormularioNascimento.vue?vue&type=script&lang=js&"
export * from "./ImpressaoFormularioNascimento.vue?vue&type=script&lang=js&"
import style0 from "./ImpressaoFormularioNascimento.vue?vue&type=style&index=0&id=81d6b4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d6b4f0",
  null
  
)

export default component.exports